export default __webpack_public_path__ + "2deca1119bd4d1753091db6ff82b41b6.jpg";